/* eslint-disable max-len */
import subModuleKeys from '@/modules/constants/subModuleKeys';

const OrganizerDesignModule = () => import(/* webpackChunkName: "organizerdesign" */ '@/components/modules/graphicalProfile/branding/OrganizerDesignModule.vue');
const WebDesignModule = () => import(/* webpackChunkName: "webdesign" */ '@/components/modules/graphicalProfile/branding/WebDesignModule.vue');
const PostsaleModule = () => import(/* webpackChunkName: "postsale" */ '@/components/modules/graphicalProfile/PostsaleModule.vue');
const TicketDesignModule = () => import(/* webpackChunkName: "ticketdesign" */ '@/components/modules/graphicalProfile/TicketDesignModule.vue');
const TicketEmailDesignModule = () => import(/* webpackChunkName: "ticketemaildesign" */ '@/components/modules/graphicalProfile/TicketEmailDesignModule.vue');
const MarketingMaterialModule = () => import(/* webpackChunkName: "marketingmaterial" */ '@/components/modules/graphicalProfile/MarketingMaterialModule.vue');

const subModules = {
  [subModuleKeys.ORGANIZER_DESIGN]: {
    component: OrganizerDesignModule,
    name: subModuleKeys.ORGANIZER_DESIGN,
    path: '/graphics/organizer',
    props: { moduleKey: subModuleKeys.ORGANIZER_DESIGN },
  },
  [subModuleKeys.WEB_DESIGN]: {
    canReuse: true,
    name: subModuleKeys.WEB_DESIGN,
    component: WebDesignModule,
    path: '/graphics/web/:eventId?',
    meta: {
      noTransition: true,
      applyEventUnderEdit: true,
    },
    props: (route) => (
      {
        moduleKey: subModuleKeys.WEB_DESIGN,
        eventId: route
          ? parseInt(route.params.eventId, 10)
          : null,
      }),
  },
  [subModuleKeys.POST_SALE_LINKS]: {
    component: PostsaleModule,
    name: subModuleKeys.POST_SALE_LINKS,
    path: '/graphics/postsale',
    props: { moduleKey: subModuleKeys.POST_SALE_LINKS },
  },
  [subModuleKeys.POST_SALE]: {
    component: PostsaleModule,
    name: subModuleKeys.POST_SALE,
    path: '/graphics/postsale',
    props: { moduleKey: subModuleKeys.POST_SALE },
  },
  [subModuleKeys.POST_SALE_LINKS]: {
    component: PostsaleModule,
    name: subModuleKeys.POST_SALE_LINKS,
    path: '/graphics/postsale',
    props: { moduleKey: subModuleKeys.POST_SALE_LINKS },
  },
  [subModuleKeys.TICKET_DESIGN]: {
    component: TicketDesignModule,
    name: subModuleKeys.TICKET_DESIGN,
    path: '/graphics/ticketdesign',
    props: { moduleKey: subModuleKeys.TICKET_DESIGN },
  },
  [subModuleKeys.TICKET_EMAIL_DESIGN]: {
    component: TicketEmailDesignModule,
    name: subModuleKeys.TICKET_EMAIL_DESIGN,
    path: '/graphics/ticketemaildesign',
    props: { moduleKey: subModuleKeys.TICKET_EMAIL_DESIGN },
  },
  [subModuleKeys.MARKETING_MATERIAL]: {
    component: MarketingMaterialModule,
    name: subModuleKeys.MARKETING_MATERIAL,
    path: '/marketingmaterial',
    props: { moduleKey: subModuleKeys.MARKETING_MATERIAL },
  },
};

export default subModules;
